<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのページはh1タグとh2タグがbodyタグの中に含まれています。
        </p>
        <p v-else>
          あなたのページはh1タグとh2タグがbodyタグの中に含まれていません。
        </p>
      </div>
    </li>
    <li
      v-if="headingH1s.length || headingH2s.length"
      class="c-list--checkup__item"
    >
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <dl v-if="headingH1s.length">
          <dt>h1タグの内容</dt>
          <dd>
            <ul class="c-list--disc">
              <li v-for="(item, index) in headingH1s" :key="index">
                {{ item }}
              </li>
            </ul>
          </dd>
        </dl>
        <dl v-if="headingH2s.length">
          <dt>h2タグの内容</dt>
          <dd>
            <ul class="c-list--disc">
              <li v-for="(item, index) in headingH2s" :key="index">
                {{ item }}
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          ページ内のコンテンツ内容に沿って、見出しとなる内容をｈ１やｈ２タグに記載し設置する。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    headingH1s() {
      if (this.detail.h1s) {
        // [""]みたいな配列が返ってくるケースがあったので
        return this.detail.h1s.filter(item => item);
      }
      return [];
    },
    headingH2s() {
      if (this.detail.h2s) {
        return this.detail.h2s.filter(item => item);
      }
      return [];
    }
  }
};
</script>
